export const VERSION_BANNER = {
  START: 0,
  EDITION: 1,
  COMPLETED: 2,
};
